export default {"src":"/_next/static/media/list_40.f5c47146.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};